"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFiltersEndpointRequest = exports.FilterTypes = void 0;
const ProductSearchQuery_1 = require("../../types/ProductSearchQuery");
var FilterTypes;
(function (FilterTypes) {
    FilterTypes["BOOLEAN"] = "boolean";
    FilterTypes["ATTRIBUTES"] = "attributes";
    FilterTypes["IDENTIFIER"] = "identifier";
    FilterTypes["RANGE"] = "range";
})(FilterTypes || (exports.FilterTypes = FilterTypes = {}));
function createFiltersEndpointRequest(parameters) {
    const withParam = parameters.with ? parameters.with.join(',') : 'values';
    return {
        method: 'GET',
        endpoint: 'filters',
        params: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (withParam ? { with: withParam } : undefined)), (parameters.including
            ? { including: parameters.including.join(',') }
            : undefined)), (parameters.campaignKey
            ? { campaignKey: parameters.campaignKey }
            : undefined)), (parameters.includeSoldOut
            ? { includeSoldOut: parameters.includeSoldOut }
            : undefined)), (parameters.includeSellableForFree
            ? { includeSellableForFree: parameters.includeSellableForFree }
            : undefined)), (0, ProductSearchQuery_1.queryParamsFromProductSearchQuery)(parameters.where)), (parameters.orFiltersOperator &&
            parameters.orFiltersOperator.length > 1
            ? { orFiltersOperator: parameters.orFiltersOperator.join(',') }
            : undefined)),
    };
}
exports.createFiltersEndpointRequest = createFiltersEndpointRequest;
